module.exports = __webpack_public_path__ + "static/media/4ODA5.302f0e92.jpg";